var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuberginesBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.028,
    height: 16.535,
    viewBox: "0 0 16.028 16.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3611",
    "data-name": "Group 3611",
    transform: "translate(0.366 0.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M2380.967,402.154a1.992,1.992,0,0,1,2.316,1.593,1.789,1.789,0,0,1-.427,1.722,3.053,3.053,0,0,1-.35.325,8.777,8.777,0,0,0-3.193,7.56s.6,4.085-3.256,4.548a3.878,3.878,0,0,1-4.235-2.894q-.043-.177-.069-.354a10.689,10.689,0,0,1,8.435-12.374q.39-.078.779-.125",
    transform: "translate(-2371.583 -402.134)",
    fill: "none",
    stroke: "#22294D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M2397.575,405.514a.97.97,0,1,1,1.094,1.456s.467.308,1.6-.28a3.221,3.221,0,0,0-.611,1.314,2.1,2.1,0,0,0,1.522-.321,2.041,2.041,0,0,0-.282,1.842",
    transform: "translate(-2391.167 -404.681)",
    fill: "none",
    stroke: "#22294D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M2418.314,404.734a2.985,2.985,0,0,1,3.667,1.249",
    transform: "translate(-2406.794 -403.941)",
    fill: "none",
    stroke: "#22294D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuberginesBlue);
export default __webpack_public_path__ + "static/media/aubergines_blue.910b25d09fab4fc87dc05a54ebff09b4.svg";
export { ForwardRef as ReactComponent };